module.exports = __webpack_public_path__ + "static/media/lincoln-minus.34eca40e.svg";